import { Moon, Sun } from '@tamagui/lucide-icons';
import { Row } from '@unistocks/components/layout/flex';
import {
  useActiveColorScheme,
  useIsDarkMode
} from '@unistocks/shared/hooks/use-active-color-scheme';
import React from 'react';
import { Switch, SwitchProps } from 'tamagui';

export const ThemeSwitch: React.FC<SwitchProps> = ({ gap = '$2', ...props }) => {
  const isDarkMode = useIsDarkMode();
  const { toggleDarkMode } = useActiveColorScheme();

  return (
    <Row gap={gap} alignItems={'center'} cursor="pointer" onPress={toggleDarkMode}>
      <Moon color={isDarkMode ? '$gray12' : '$gray10'} size={props.size} scale={0.85} />
      <Switch
        bg={'$gray5'}
        bc={'$gray7'}
        cursor="pointer"
        {...props}
        checked={!isDarkMode}
        onCheckedChange={toggleDarkMode}
      >
        <Switch.Thumb transition="quicker" />
      </Switch>
      <Sun color={isDarkMode ? '$yellow8' : '$yellow10'} size={props.size} scale={0.85} />
    </Row>
  );
};

ThemeSwitch.displayName = 'ThemeSwitch';
